/*
 *
 *  actions
 *
 */

import {
  //LOAD_BIRTHDAY_LIST
  LOAD_BIRTHDAY_LIST,
  LOAD_BIRTHDAY_LIST_SUCCESS,
  LOAD_BIRTHDAY_LIST_ERROR,
  LOAD_DASHBOARD_ATTENDANCE,
  LOAD_DASHBOARD_ATTENDANCE_SUCCESS,
  LOAD_DASHBOARD_ATTENDANCE_ERROR,
  //LOAD_DASHBOARD_CHECKINOUT
  LOAD_DASHBOARD_CHECKINOUT,
  LOAD_DASHBOARD_CHECKINOUT_SUCCESS,
  LOAD_DASHBOARD_CHECKINOUT_ERROR,
  LOAD_HOLIDAY_LIST,
  LOAD_HOLIDAY_LIST_SUCCESS,
  LOAD_HOLIDAY_LIST_ERROR,
  LOAD_YEARLY_LEAVE,
  LOAD_YEARLY_LEAVE_SUCCESS,
  LOAD_YEARLY_LEAVE_ERROR,
  LOAD_DAILY_PERCENTAGE_LIST,
  LOAD_DAILY_PERCENTAGE_LIST_SUCCESS,
  LOAD_DAILY_PERCENTAGE_LIST_ERROR,
  LOAD_WEEKLY_PERCENTAGE_LIST,
  LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_WEEKLY_PERCENTAGE_LIST_ERROR,
  LOAD_MONTHLY_PERCENTAGE_LIST,
  LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_MONTHLY_PERCENTAGE_LIST_ERROR,
  LOAD_EMPLOYEE_STATUS,
  LOAD_EMPLOYEE_STATUS_SUCCESS,
  LOAD_EMPLOYEE_STATUS_ERROR,
  LOAD_ATTENDANCE_OVERVIEW,
  LOAD_ATTENDANCE_OVERVIEW_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_ERROR,
  LOAD_DEPARTMENT,
  LOAD_DEPARTMENT_SUCCESS,
  LOAD_DEPARTMENT_ERROR,
  LOAD_ATTENDANCE_OVERVIEW_TODAY,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR,

  LOAD_ATTENDANCE_OVERVIEW_THISWEEK,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR,
  
   LOAD_EMPLOYEE_TYPE,
  LOAD_EMPLOYEE_TYPE_SUCCESS,
  LOAD_EMPLOYEE_TYPE_ERROR,


  LOAD_ATTENDANCE_OVERVIEW_THISMONTH,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR,
  LOAD_LATE,
  LOAD_LATE_SUCCESS,
  LOAD_LATE_ERROR
  
} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}

//loadBirthdayList
export function loadBirthdayList(searchFilter) {
  return {
    type: LOAD_BIRTHDAY_LIST,
    searchFilter,
  };
}
//birthday_list
export function loadBirthdayListSuccess(birthday_list, success) {
  return {
    type: LOAD_BIRTHDAY_LIST_SUCCESS,
    birthday_list,
    success,
  };
}

export function loadBirthdayListError(error) {
  return {
    type: LOAD_BIRTHDAY_LIST_ERROR,
    error,
  };
}

//loadDashboardCheckinOut
export function loadDashboardCheckinOut(searchFilter) {
  return {
    type: LOAD_DASHBOARD_CHECKINOUT,
    searchFilter,
  };
}

export function loadDashboardCheckinOutSuccess(checkinOut_list, success) {
  console.log(checkinOut_list, "checkinOut_list");
  return {
    type: LOAD_DASHBOARD_CHECKINOUT_SUCCESS,
    checkinOut_list,
    success,
  };
}

export function loadDashboardCheckinOutError(error) {
  return {
    type: LOAD_DASHBOARD_CHECKINOUT_ERROR,
    error,
  };
}
//loadDashboardAttendance
export function loadDashboardAttendance(searchFilter) {
  return {
    type: LOAD_DASHBOARD_ATTENDANCE,
    searchFilter,
  };
}

export function loadDashboardAttendanceSuccess(
  Dashboardattendence_list,
  success
) {
  return {
    type: LOAD_DASHBOARD_ATTENDANCE_SUCCESS,
    Dashboardattendence_list,
    success,
  };
}

export function loadDashboardAttendanceError(error) {
  return {
    type: LOAD_DASHBOARD_ATTENDANCE_ERROR,
    error,
  };
}

//loadYearlyLeave
export function loadYearlyLeave(searchFilter) {
  return {
    type: LOAD_YEARLY_LEAVE,
    searchFilter,
  };
}

export function loadYearlyLeaveSuccess(Yearlyleave_list, success) {
  return {
    type: LOAD_YEARLY_LEAVE_SUCCESS,
    Yearlyleave_list,
    success,
  };
}

export function loadYearlyLeaveError(error) {
  return {
    type: LOAD_YEARLY_LEAVE_ERROR,
    error,
  };
}

//loadBirthdayList
export function loadHolidayList(searchFilter) {
  return {
    type: LOAD_HOLIDAY_LIST,
    searchFilter,
  };
}
//birthday_list
export function loadHolidayListSuccess(holiday_list, success) {
  return {
    type: LOAD_HOLIDAY_LIST_SUCCESS,
    holiday_list,
    success,
  };
}

export function loadHolidayListError(error) {
  return {
    type: LOAD_HOLIDAY_LIST_ERROR,
    error,
  };
}

//loadDailyPercentageList
export function loadDailyPercentageList(searchFilter) {
  return {
    type: LOAD_DAILY_PERCENTAGE_LIST,
    searchFilter,
  };
}

export function loadDailyPercentageListSuccess(daily_list, success) {
  return {
    type: LOAD_DAILY_PERCENTAGE_LIST_SUCCESS,
    daily_list,
    success,
  };
}

export function loadDailyPercentageListError(error) {
  return {
    type: LOAD_DAILY_PERCENTAGE_LIST_ERROR,
    error,
  };
}

//loadWeeklyPercentageList
export function loadWeeklyPercentageList(searchFilter) {
  return {
    type: LOAD_WEEKLY_PERCENTAGE_LIST,
    searchFilter,
  };
}

export function loadWeeklyPercentageListSuccess(weekly_list, success) {
  return {
    type: LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS,
    weekly_list,
    success,
  };
}

export function loadWeeklyPercentageListError(error) {
  return {
    type: LOAD_WEEKLY_PERCENTAGE_LIST_ERROR,
    error,
  };
}

//loadMonthlyPercentageList
export function loadMonthlyPercentageList(searchFilter) {
  return {
    type: LOAD_MONTHLY_PERCENTAGE_LIST,
    searchFilter,
  };
}

export function loadMonthlyPercentageListSuccess(monthly_list, success) {
  return {
    type: LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS,
    monthly_list,
    success,
  };
}

export function loadMonthlyPercentageListError(error) {
  return {
    type: LOAD_MONTHLY_PERCENTAGE_LIST_ERROR,
    error,
  };
}

//EMPLOYEE STATUS
export function loadEmployeeStatusList(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_STATUS,
    searchFilter,
  };
}

export function loadEmployeeStatusListSuccess(employeeStatus_list, success) {
  return {
    type: LOAD_EMPLOYEE_STATUS_SUCCESS,
    employeeStatus_list,
    success,
  };
}

export function loadEmployeeStatusListError(error) {
  return {
    type: LOAD_EMPLOYEE_STATUS_ERROR,
    error,
  };
}


//Employee Overview
export function loadAttendanceOverview(searchFilter) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW,
    searchFilter,
  };
}

export function loadAttendanceOverviewSuccess(AttendanceOverview_list, success) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_SUCCESS,
    AttendanceOverview_list,
    success,
  };
}

export function loadAttendanceOverviewError(error) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_ERROR,
    error,
  };
}


//Attendance Overview Today
export function loadAttendanceTodayOverview(searchFilter) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_TODAY,
    searchFilter,
  };
}

export function loadAttendanceTodayOverviewSuccess(attendanceTodayOverview_list, success) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS,
    attendanceTodayOverview_list,
    success,
  };
}

export function loadAttendanceTodayOverviewError(error) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR,
    error,
  };
}


//Attendance Overview This Week
export function loadAttendanceThisWeekOverview(searchFilter) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISWEEK,
    searchFilter,
  };
}

export function loadAttendanceThisWeekOverviewSuccess(attendanceThisWeekOverview_list, success) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS,
    attendanceThisWeekOverview_list,
    success,
  };
}

export function loadAttendanceThisWeekOverviewError(error) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR,
    error,
  };
}



//Attendance Overview This month
export function loadAttendanceThisMonthOverview(searchFilter) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISMONTH,
    searchFilter,
  };
}

export function loadAttendanceThisMonthOverviewSuccess(attendanceThisMonthOverview_list, success) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS,
    attendanceThisMonthOverview_list,
    success,
  };
}

export function loadAttendanceThisMonthOverviewError(error) {
  return {
    type: LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR,
    error,
  };
}

//


//loadDepartment
export function loadDepartment(searchFilter) {
  return {
    type: LOAD_DEPARTMENT,
    searchFilter,
  };
}

export function loadDepartmentSuccess(department_list, success) {
  return {
    type: LOAD_DEPARTMENT_SUCCESS,
    department_list,
    success,
  };
}

export function loadDepartmentError(error) {
  return {
    type: LOAD_DEPARTMENT_ERROR,
    error,
  };
}

//loadLate
export function loadLate(searchFilter) {
  return {
    type: LOAD_LATE,
    searchFilter,
  };
}

export function loadLateSuccess(late_list, success) {
  return {
    type: LOAD_LATE_SUCCESS,
    late_list,
    success,
  };
}

export function loadLateError(error) {
  return {
    type: LOAD_LATE_ERROR,
    error,
  };
}

//loadLate
export function loadEmployeeType(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_TYPE,
    searchFilter,
  };
}

export function loadEmployeeTypeSuccess(employeeType_list, success) {
  return {
    type: LOAD_EMPLOYEE_TYPE_SUCCESS,
    employeeType_list,
    success,
  };
}

export function loadEmployeeTypeError(error) {
  return {
    type: LOAD_EMPLOYEE_TYPE_ERROR,
    error,
  };
}


const actions = {
  loadBirthdayList,
  loadBirthdayListSuccess,
  loadBirthdayListError,
  loadDashboardCheckinOut,
  loadDashboardCheckinOutSuccess,
  loadDashboardCheckinOutError,
  loadRecordsCacheHit,
  loadDashboardAttendance,
  loadDashboardAttendanceSuccess,
  loadDashboardAttendanceError,
  loadYearlyLeave,
  loadYearlyLeaveSuccess,
  loadYearlyLeaveError,
  loadHolidayList,
  loadHolidayListSuccess,
  loadHolidayListError,
  loadDailyPercentageList,
  loadDailyPercentageListSuccess,
  loadDailyPercentageListError,
  loadWeeklyPercentageList,
  loadWeeklyPercentageListSuccess,
  loadWeeklyPercentageListError,
  loadMonthlyPercentageList,
  loadMonthlyPercentageListSuccess,
  loadMonthlyPercentageListError,
  loadEmployeeStatusList,
  loadEmployeeStatusListSuccess,
  loadEmployeeStatusListError,
  loadAttendanceOverview,
  loadAttendanceOverviewSuccess,
  loadAttendanceOverviewError,
  loadDepartment,
  loadDepartmentSuccess,
  loadDepartmentError,
  loadAttendanceTodayOverview,
  loadAttendanceTodayOverviewSuccess,
  loadAttendanceTodayOverviewError,
  loadAttendanceThisWeekOverview,
  loadAttendanceThisWeekOverviewSuccess,
  loadAttendanceThisWeekOverviewError,
  loadAttendanceThisMonthOverview,
  loadAttendanceThisMonthOverviewSuccess,
  loadAttendanceThisMonthOverviewError,
  loadLate,
  loadLateSuccess,
  loadLateError,
  loadEmployeeType,
  loadEmployeeTypeSuccess,
  loadEmployeeTypeError
};

export default actions;
